import FacebookPageLike from './FacebookPageLike'

const boosters = {
	facebookPageLike: FacebookPageLike,
}

export default boosters